
export const Countdown = (value, options) => {
    let res;

    const distance = value - new Date().getTime();

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString();
    const min = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString();
    const sec = Math.floor((distance % (1000 * 60)) / 1000).toString();

    if (hours <= 0 && min <= 0 && sec <= 0) {
        res = false
    } else {
        res = !options ? 
        `${hours.length == 1 ? "0"+hours : hours}:${min.length == 1 ? "0"+min : min}:${sec.length == 1 ? "0"+sec : sec}` 
        : options == "seconds" ? sec : options == "minutes" ? min : hours
    }

    return res

}
